import moment from "moment";

export const validateDateForTask = (date) => {
  // Obtener la fecha actual
  const currentDate = moment().startOf("day");
  const nextDay = moment(currentDate).add(1, "day");

  const isAfterCurrentDate = moment(date).isSameOrAfter(nextDay, "day");
  const isSameMonth = moment(date).isSame(currentDate, "month");

  return isAfterCurrentDate && isSameMonth;
};
